import { getVoucherCode } from "src/app/functions/common-functions";
import { VoucherPaymentDialogComponent } from "src/app/components/voucher-payment-dialog/voucher-payment-dialog.component";
import { PaymentAvailabilityService } from "src/app/services/payment-availability.service";
import { PaymentContext } from "src/app/models/payment-availability.model";
import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, OnDestroy, ViewChild, inject } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CardButtonComponent } from "../../../components/ui-components/buttons/card-button/card-button.component";
import { FormInputComponent } from "../../../components/ui-components/forms/form-input/form-input.component";
import { FormInputType } from "../../../components/ui-components/forms/form-input/form-input.model";
import {
  CardButtonBackground,
  CardButtonSize,
} from "../../../components/ui-components/buttons/card-button/card-button.model";
import { BehaviorSubject, catchError, finalize, lastValueFrom, of, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  IExecuteProcedureRequest,
  IExecuteProcedureResult,
  IGetTripRequestParams,
  IInsertDertHeadersResultData,
  LoginService,
  PopUpDialogInformalService,
  ResultCode,
  SharedService,
  StateService,
} from "../../../services";
import { SobitService } from "../../../services/sobit.service";
import { PayByCardRequest, PayByCardResult } from "../../../models/sobit-request-data";
import { VirtualProductType } from "src/app/enums/virtual-product-type.enum";
import { PopUpInformalType } from "src/app/components/ui-components/pop-ups/pop-up-informal/pop-up-informal.model";
import { NgxSpinnerService } from "ngx-spinner";
import { IBlobExportData, IInsertHeaderRecordParams } from "src/app/services/model/sp-procedures-params.model";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentsComponent } from "src/app/components/payments/payments.component";
import { PaymentTypesService } from "src/app/services/payment-types.service";
import { ActionButtonComponent } from "src/app/components/ui-components/buttons/action-button/action-button.component";
import { ActionButtonSize } from "src/app/components/ui-components/buttons/action-button/action-button.model";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IPayment, IReservationData, PaymentConditionItem } from "src/app/services/model/get-trip-data.model";
import { SharedApiService } from "src/app/services/api/sharedApi.service";
import { IFlyTicketRequest } from "src/app/services/model/get-fly-ticket-data.model";
import { ProcedureNameEnum } from "src/app/enums/procedure-name.enum";
import { TenderType } from "src/app/services/model/tender-type.enum";
import { CardPaymentDialogComponent } from "src/app/components/card-payment-dialog/card-payment-dialog.component";
import { OfflineCardPaymentDialogComponent } from "src/app/components/offline-card-payment-dialog/offline-card-payment-dialog.component";
import { FlightToPaymentDialogModel, OfflinePaymentDialogContext, PaymentDialogModel, PaymentDialogResult, ToPaymentDialogModel } from "src/app/models/payment-dialog.model";
import { MatDialog } from "@angular/material/dialog";
import { CashPaymentDialogComponent } from "src/app/components/cash-payment-dialog/cash-payment-dialog.component";
import { FlyTicketType } from "src/app/enums/fly-ticket-type.enum";
import { QueryParamEnum } from "src/app/enums/query-param.enum";
import { IFlyTicketFormModel } from "src/app/models/fly-ticket-form.model";
import { PaymentStatusCheckerService } from "src/app/services/payment-status-checker.service";
import { ReportExportService } from "src/app/services/report-export.service";
import { HeaderProcessingService } from "src/app/services/header-processing.service";
import { DbSchemeEnum } from "src/app/enums/db-scheme.enum";
import { BenefitPaymentDialogComponent } from "src/app/components/benefit-payment-dialog/benefit-payment-dialog.component";
import { IGetCashMovementsSummaryRequest, IGetCashMovementsSummaryResponse, IPaymentAttribute } from "src/app/services/model/pos.api.model";
import { DropdownComponent } from "src/app/components/ui-components/dropdown/dropdown.component";
import { DropdownOption } from "src/app/components/ui-components/dropdown/dropdown.model";
import { StateDropdownService } from "src/app/services/state-dropdown.service";
import { SharedModule } from "src/app/shared.module";
import { PaymentStatusEnum } from "src/app/enums/payment-status.enum";
import { OthersPaymentDialogComponent } from "src/app/components/others-payment-dialog/others-payment-dialog.component";
import {
  ReturnPaymentMethod,
  isAuthorizedForReturnPaymentMethod,
} from "src/app/guards/authorization-policy";


@Component({
  providers: [PaymentAvailabilityService],
  selector: "app-fly-ticket",
  templateUrl: "./fly-ticket.component.html",
  styleUrls: ["./fly-ticket.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormInputComponent,
    CardButtonComponent,
    DropdownComponent,
    ReactiveFormsModule,
    PaymentsComponent,
    ActionButtonComponent,
    FontAwesomeModule,
    SharedModule
  ]
})
export class FlyTicketComponent implements OnDestroy, AfterViewInit {
  readonly paymentAvailability = inject(PaymentAvailabilityService);

  get paymentContext(): PaymentContext {
    return { operation: this.isReturn ? "return" : "sale", documentType: this.viewType === FlyTicketType.ETravel ? "e-travel" : "fly-ticket" };
  }

  private preparePaymentDialog(data: PaymentDialogModel): Promise<PaymentDialogModel> {
    return this.paymentAvailability.prepare(data, this.paymentContext);
  }



  @ViewChild('variableSymbolInput') variableSymbolInput: FormInputComponent;

  private _sharedService = inject(SharedService);
  private _stateService = inject(StateService);
  private _sharedApiService = inject(SharedApiService);
  private _sobitService = inject(SobitService);
  private _paymentTypesService = inject(PaymentTypesService);
  private _popUpDialogInformalService = inject(PopUpDialogInformalService);
  private _activatedRoute = inject(ActivatedRoute);
  private _loginService = inject(LoginService);
  private _router = inject(Router);
  private _dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  private readonly _spinner = inject(NgxSpinnerService);
  private _route = inject(ActivatedRoute);
  private readonly _paymentStatusCheckerService = inject(PaymentStatusCheckerService);
  private readonly _reportExportService = inject(ReportExportService);
  private readonly _headerProcessingService = inject(HeaderProcessingService);
  private readonly _stateDropdownService = inject(StateDropdownService);

  private destroyObservable$ = new Subject<any>();
  private checkDocumentSubject$ = new Subject<void>();

  benefitPaymentEnabled = this._paymentTypesService.benefitPaymentEnabled;

  public FormInputType = FormInputType;
  public TenderType = TenderType;
  public CardButtonSize = CardButtonSize;
  public CardButtonBackground = CardButtonBackground;
  public FlyTicketType = FlyTicketType;
  public PaymentStatusEnum = PaymentStatusEnum;
  public readonly ReturnPaymentMethod = ReturnPaymentMethod;

  ActionButtonSize = ActionButtonSize;

  paymentDisabled: boolean = true;
  isReturn: boolean = false;
  voucherCodeFromQuery?: string;
  flyTicketForm!: FormGroup;
  availableCashForReturn: number | null = null;

  viewType: FlyTicketType = FlyTicketType.FlyTicket;

  allowPaymentByCard = this._sobitService.allowPaymentByCard;
  public checkSobitPaymentEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  payments: BehaviorSubject<IPayment[]> = new BehaviorSubject<IPayment[]>([]);
  reservationData: IReservationData | null = null;
  public stateOptions: DropdownOption[] = [];

  private id: string;
  
  private async updateStateOptions(currentValue?: string): Promise<void> {
    this.stateOptions = await this._stateDropdownService.getStateOptions(currentValue);
  }

  get paymentsSummaryValue(): number {
    return Math.round(this.completedPaymentsTotal * 100) / 100;
  }

  get paymentsSummaryLabelKey(): string {
    return this.isReturn ? "webPos.MaxReturnValue" : "webPos.payedPrice";
  }

  get paymentsSummaryCurrency(): string {
    return this.payments.getValue().find(payment => !!payment?.Currency)?.Currency
      || this.reservationData?.reservation?.paymentSummary?.totalPaid?.currency
      || this.reservationData?.reservation?.paymentSummary?.totalPrice?.currency
      || this._loginService.user.CurrencyCode;
  }

  get canProcessCashReturn(): boolean {
    if (!this.isReturn) {
      return true;
    }

    const availableCash = this.availableCashForReturn ?? Infinity;
    return Math.min(this.returnableAmount, availableCash) > 0;
  }

  get canProcessNonCashReturn(): boolean {
    return !this.isReturn || this.returnableAmount > 0;
  }

  private get completedPaymentsTotal(): number {
    const currentPayments = this.payments.getValue();
    const sum = currentPayments
      .filter(payment => payment.Status === PaymentStatusEnum.Done)
      .reduce((sum, payment) => sum + (Number(payment?.Amount) || 0), 0);

    if (sum > 0 || currentPayments.length > 0) {
      return Math.round(sum * 100) / 100;
    }

    return Math.round((Number(this.reservationData?.reservation?.paymentSummary?.totalPaid?.amount) || 0) * 100) / 100;
  }

  private get returnableAmount(): number {
    return Math.max(0, Math.round(this.completedPaymentsTotal * 100) / 100);
  }

  private async loadAvailableCashForReturn(): Promise<void> {
    if (!this.isReturn) {
      this.availableCashForReturn = null;
      return;
    }

    const cashPaymentType = await this._sharedService.getCashPaymentTypeForCurrency();

    if (!cashPaymentType?.Name) {
      this.availableCashForReturn = null;
      return;
    }

    try {
      const request: IExecuteProcedureRequest<IGetCashMovementsSummaryRequest> = {
        DbScheme: DbSchemeEnum.Dert,
        ProcedureName: ProcedureNameEnum.GetCashMovementsSummary,
        Parameters: {
          CurrencyCode: this._loginService.user?.CurrencyCode,
          PaymentName: cashPaymentType.Name,
          ReturnToResult: 0,
        } as IGetCashMovementsSummaryRequest,
      };

      const result = await this._sharedApiService.executeProcedure<IGetCashMovementsSummaryRequest, IExecuteProcedureResult<IGetCashMovementsSummaryResponse>>(request);
      this.availableCashForReturn = result?.data?.TotalMovement ?? null;
    } catch (error) {
      console.error("Failed to load available cash for fly-ticket return", error);
      this.availableCashForReturn = null;
    }
  }

  private async validateReturnPayment(paymentValue: number, paymentType: TenderType): Promise<boolean> {
    if (!this.isReturn) {
      return true;
    }

    const normalizedPaymentValue = Math.abs(Number(paymentValue) || 0);

    if (normalizedPaymentValue <= 0 || normalizedPaymentValue > this.returnableAmount) {
      await this._popUpDialogInformalService.confirm({
        title: this.translate.instant("webPos.Errors.Error"),
        message: this.translate.instant("webPos.Errors.MaxAllowedAmountExceeded"),
        type: PopUpInformalType.Error,
      });
      return false;
    }

    if (
      paymentType === TenderType.Cash
      && this.availableCashForReturn !== null
      && normalizedPaymentValue > this.availableCashForReturn
    ) {
      await this._popUpDialogInformalService.confirm({
        title: this.translate.instant("webPos.Errors.Error"),
        message: this.translate.instant("webPos.Errors.InsufficientValue"),
        type: PopUpInformalType.Error,
      });
      return false;
    }

    return true;
  }

  async ngOnInit() {
    this.isReturn = this._route.snapshot.data["type"] === "return";
    this.viewType = this._route.snapshot.data["viewType"] as FlyTicketType;
    this.voucherCodeFromQuery = this._route.snapshot.queryParamMap.get(QueryParamEnum.Voucher)?.trim() || undefined;

    await this.createFlyTicketForm();
    await this.paymentAvailability.refresh();

    this.id = this._activatedRoute.snapshot.paramMap.get('id');
    if (this.id) {
      this.flyTicketForm.get("variableSymbol").setValue(this.id);
      // If there's an ID from route, auto-search for itw02
      await this.checkExistingDocument(this.id);
    }

    await this._sobitService.generateClient();
  }

  async ngAfterViewInit() {
  }

  private async createFlyTicketForm() {
    const flyTicketNameValidators = this.viewType === FlyTicketType.ETravel ? [] : [Validators.required];

    this.flyTicketForm = new FormGroup({
      variableSymbol: new FormControl<string>({ value: "", disabled: false }, [Validators.required]),
      flyTicketName: new FormControl<string>({ value: "", disabled: this.paymentDisabled }, flyTicketNameValidators),
      description: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
      customerName: new FormControl<string>({ value: "", disabled: this.paymentDisabled }, [Validators.required]),
      customerSurname: new FormControl<string>({ value: "", disabled: this.paymentDisabled }, [Validators.required]),
      customerEmailAddress: new FormControl<string>({ value: "", disabled: this.paymentDisabled }, [Validators.required, Validators.email]),
      //customerPhoneNumber: new FormControl<string>({ value: "", disabled: this.paymentDisabled }, [Validators.required, phoneNumberValidator()]),
      customerStreet: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
      customerCity: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
      customerCountry: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
      customerZipCode: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
      customerCIN: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
      customerTIN: new FormControl<string>({ value: "", disabled: this.paymentDisabled }),
    });

    await this.updateStateOptions(this.flyTicketForm.get("customerCountry")?.value);
  }

  private normalizeReservationData(tripData?: IReservationData | null): IReservationData | null {
    if (!tripData) {
      return null;
    }

    tripData.reservation ??= {} as IReservationData["reservation"];
    tripData.reservation.paymentSummary ??= {
      isPaid: false,
      totalPrice: {
        amount: 0,
        currency: this._loginService.user.CurrencyCode,
      },
      totalPaid: {
        amount: 0,
        currency: this._loginService.user.CurrencyCode,
      },
      paymentConditionItems: [],
      paymentPaidItems: [],
    } as IReservationData["reservation"]["paymentSummary"];

    tripData.reservation.paymentSummary.totalPrice ??= {
      amount: 0,
      currency: this._loginService.user.CurrencyCode,
    };
    tripData.reservation.paymentSummary.totalPaid ??= {
      amount: 0,
      currency: this._loginService.user.CurrencyCode,
    };
    tripData.reservation.paymentSummary.paymentConditionItems ??= [];
    tripData.reservation.paymentSummary.paymentPaidItems ??= [];
    tripData.payments ??= [];

    return tripData;
  }

  private getPaymentsForDisplay(tripData?: IReservationData | null): IPayment[] {
    const currentPayments = tripData?.payments ?? [];

    if (currentPayments.length > 0) {
      return currentPayments;
    }

    return (tripData?.reservation?.paymentSummary?.paymentPaidItems ?? [])
      .map((payment, index) => this.mapPaymentSummaryItemToPayment(payment, index));
  }

  private mapPaymentSummaryItemToPayment(payment: PaymentConditionItem, index: number): IPayment {
    const paidDate = payment?.paidDate || payment?.dueDate || new Date().toISOString();

    return {
      Id: `reservation-payment-${paidDate}-${index}`,
      No: null,
      PaymentName: null,
      Description: null,
      PaymentDescription: this.translate.instant("webPos.Payment"),
      PaidDate: paidDate,
      Amount: Number(payment?.amount) || 0,
      Currency: payment?.currency || this._loginService.user.CurrencyCode,
      Status: payment?.status ?? PaymentStatusEnum.Done,
      PaymentType: TenderType.Other,
      BusinessUnitInternalNumber: null,
      DataSource: "tiger",
      PaymentAttributes: null,
      HeaderID: null,
      HeaderUID: null,
      PosHeaderUID: null,
    };
  }

  private async applyReservationDataToForm(tripData?: IReservationData): Promise<void> {
    const reservation = tripData?.reservation;
    const customer = reservation?.customer;
    const address = customer?.address;
    const customerStreet = [address?.street, address?.streetNo]
      .filter((value): value is string => !!value)
      .join(" ")
      .trim();

    this.flyTicketForm.patchValue({
      flyTicketName: reservation?.destinationName ?? "",
      description: "",
      customerName: customer?.firstName ?? "",
      customerSurname: customer?.lastName ?? "",
      customerEmailAddress: customer?.emailAddress ?? "",
      customerStreet,
      customerCity: address?.city ?? "",
      customerCountry: address?.countryISO3Code ?? "",
      customerZipCode: address?.zipCode ?? "",
    }, { emitEvent: false });

    await this.updateStateOptions(address?.countryISO3Code ?? undefined);
  }

  private async applyStoredPaymentDataToForm(payment?: IPayment | null): Promise<void> {
    const dataBlob = payment?.DataBlob;

    if (!dataBlob) {
      return;
    }

    this.flyTicketForm.patchValue({
      flyTicketName: dataBlob.saleName ?? this.flyTicketForm.get("flyTicketName")?.value ?? "",
      description: dataBlob.description ?? this.flyTicketForm.get("description")?.value ?? "",
      customerName: dataBlob.customerName ?? this.flyTicketForm.get("customerName")?.value ?? "",
      customerSurname: dataBlob.customerSurname ?? this.flyTicketForm.get("customerSurname")?.value ?? "",
      customerEmailAddress: dataBlob.customerEmailAddress ?? this.flyTicketForm.get("customerEmailAddress")?.value ?? "",
      customerStreet: dataBlob.customerStreet ?? this.flyTicketForm.get("customerStreet")?.value ?? "",
      customerCity: dataBlob.customerCity ?? this.flyTicketForm.get("customerCity")?.value ?? "",
      customerCountry: dataBlob.customerCountry ?? this.flyTicketForm.get("customerCountry")?.value ?? "",
      customerZipCode: dataBlob.customerZipCode ?? this.flyTicketForm.get("customerZipCode")?.value ?? "",
      customerCIN: dataBlob.customerCIN ?? this.flyTicketForm.get("customerCIN")?.value ?? "",
      customerTIN: dataBlob.customerTIN ?? this.flyTicketForm.get("customerTIN")?.value ?? "",
    }, { emitEvent: false });

    await this.updateStateOptions(this.flyTicketForm.get("customerCountry")?.value);
  }

  private getReturnRoute(): string {
    if (this.isReturn) {
      if (this.viewType === FlyTicketType.ETravel) {
        return "/e-travel-return";
      } else {
        return "/fly-ticket-return";
      }
    }
    else {
      if (this.viewType === FlyTicketType.ETravel) {
        return "/e-travel";
      } else {
        return "/fly-ticket";
      }
    }
  }

  async checkExistingDocument(id?: string) {
    // Zrušit předchozí request
    this.checkDocumentSubject$.next();

    this.reservationData = null;
    this.payments.next([]);

    let varSymbol = this.flyTicketForm.get("variableSymbol").value;
    if (id) {
      varSymbol = id;
    } else {
      this.id = this._activatedRoute.snapshot.paramMap.get('id');
      if (varSymbol) {
        await this._router.navigate([this.getReturnRoute(), varSymbol]);
      }
    }

    this._spinner.show();

    let requestParams: IFlyTicketRequest;

    if (this.viewType === FlyTicketType.ETravel) {
      requestParams = {
        ReservationId: varSymbol,
        VirtualProductTypes: [VirtualProductType.ETravelReturn, VirtualProductType.ETravel],
      };
    }
    else {
      requestParams = {
        ReservationId: varSymbol,
        VirtualProductTypes: [VirtualProductType.FlightTicketReturn, VirtualProductType.FlightTicket],
      };
    }

    const request: IExecuteProcedureRequest<IFlyTicketRequest> = {
      Parameters: requestParams,
      ProcedureName: ProcedureNameEnum.GetTripData,
      DbScheme: DbSchemeEnum.Dert,
    };

    // Response from DERT s cancellation logikou
    const spResult: IExecuteProcedureResult<IReservationData> | null = await lastValueFrom(
      this._sharedApiService.executeProcedureObservable<IFlyTicketRequest, IExecuteProcedureResult<IReservationData>>(request)
        .pipe(
          takeUntil(this.checkDocumentSubject$),
          catchError(err => {
            if (err.name === 'EmptyError') {
              console.log('Previous request was cancelled');
              return of(null);
            }
            throw err;
          }),
          finalize(() => this._spinner.hide())
        )
    );

    if (spResult === null) {
      return;
    }

    const tripData = this.normalizeReservationData(spResult.data);

    if (!tripData || (tripData as any)?.status === "error") {
      this.reservationData = null;
      this.availableCashForReturn = null;
      const currentVariableSymbol = this.flyTicketForm.get("variableSymbol").value;
      this.paymentDisabled = false;
      await this.createFlyTicketForm();
      this.flyTicketForm.get("variableSymbol").setValue(currentVariableSymbol);
      this.flyTicketForm.enable();
    }
    // NO EXISTING DOCUMENT FOUND - CAN CONTINUE TO PAYMENT
    else if (tripData.payments.length === 0) {
      this.reservationData = tripData;
      const displayPayments = this.getPaymentsForDisplay(tripData);
      const currentVariableSymbol = this.flyTicketForm.get("variableSymbol").value;
      this.paymentDisabled = false;
      await this.createFlyTicketForm();
      this.flyTicketForm.get("variableSymbol").setValue(currentVariableSymbol);
      this.flyTicketForm.enable();
      this.payments.next(displayPayments);
      await this.applyReservationDataToForm(tripData);

      if (displayPayments.length > 0) {
        await this.loadAvailableCashForReturn();
      } else {
        this.availableCashForReturn = null;
      }
    }
    // EXISTING DOCUMENT FOUND - CHECK THE PAYMENTS
    else if (tripData.payments.length > 0) {
      this.reservationData = tripData;
      const displayPayments = this.getPaymentsForDisplay(tripData);

      this.payments.next(displayPayments);

      await this._paymentStatusCheckerService.checkAndUpdatePaymentStatusesIfPending(tripData.payments);

      if (displayPayments.length > 0) {
        await this.loadAvailableCashForReturn();
      } else {
        this.availableCashForReturn = null;
      }

      this.paymentDisabled = false;
      this.flyTicketForm.enable();
      await this.applyReservationDataToForm(tripData);

      const lastPayment = tripData.payments
        .sort((a, b) => new Date(a.PaidDate).getTime() - new Date(b.PaidDate).getTime())
        .at(-1);

      await this.applyStoredPaymentDataToForm(lastPayment);
    }

  }

  disablePayments() {
    this.paymentDisabled = true;
  }

  async applyGiftVoucher(): Promise<void> {
    if (this.isReturn || !this.voucherCodeFromQuery || this.flyTicketForm.invalid || this.paymentDisabled) return;
    const bnr = Number(this.flyTicketForm.get("variableSymbol")?.value);
    if (!Number.isFinite(bnr) || bnr <= 0) return;
    const paymentModel = this.flyTicketForm.value as IFlyTicketFormModel;
    const data = await this.preparePaymentDialog(FlightToPaymentDialogModel(paymentModel, this.payments.getValue(), false));
    if (!this.paymentAvailability.has(this.paymentContext, "voucher")) return;
    const dialogRef = this._dialog.open(VoucherPaymentDialogComponent, {
      data: {
        ...data,
        voucherCode: this.voucherCodeFromQuery,
        voucherBnr: bnr,
        voucherSource: this.reservationData?.reservation?.systemInfo?.sourceSystem ?? "PosNG",
      },
    });
    const result: IPayment | undefined = await lastValueFrom(dialogRef.afterClosed());
    if (!result) return;
    const code = result.PaymentAttributes?.find(attribute => attribute.Key === "VoucherCode")?.Value;
    if (!code || this.payments.getValue().some(payment =>
      payment.Status !== PaymentStatusEnum.Cancelled
      && getVoucherCode(payment) === code)) return;
    paymentModel.paymentValue = result.Amount;
    await this.savePayment(paymentModel, TenderType.Voucher, result.PaymentAttributes, result.PaymentName);
    await this.checkExistingDocument();
  }

  payByVoucher() {
    if (!this.canUseReturnPaymentMethod(ReturnPaymentMethod.Voucher)) {
      return;
    }

    const varSymbol = this.flyTicketForm.get("variableSymbol")?.value;
    if (!varSymbol) {
      return;
    }
    const source = this.viewType === FlyTicketType.ETravel ? "eTravel" : "flyTicket";
    this._router.navigate(["/voucher-return", varSymbol], {
      queryParams: { source },
    });
  }


  async showBenefitPaymentForm() {
    if (!this.canUseReturnPaymentMethod(ReturnPaymentMethod.Benefits)) {
      return;
    }

    const paymentModel = this.flyTicketForm.value as IFlyTicketFormModel;
    paymentModel.payments = this.payments.getValue();

    const paymentData = (await this.preparePaymentDialog(FlightToPaymentDialogModel(paymentModel, this.payments.getValue(), this.isReturn)));

    const dialogRef = this._dialog.open<BenefitPaymentDialogComponent, PaymentDialogModel, PaymentDialogResult>(BenefitPaymentDialogComponent, {
      panelClass: "full-screen-dialog",
      disableClose: true,
      data: paymentData,
    });

    const result = await lastValueFrom(dialogRef.afterClosed());
    const payment = await this.resolveBenefitPaymentDialogResult(result);

    if (payment) {
      this._spinner.show();

      paymentModel.paymentValue = payment.Amount;
      if (this.isReturn) {
        paymentModel.paymentValue = - paymentModel.paymentValue;
      }

      await this.savePayment(
        paymentModel,
        payment.PaymentType,
        payment.PaymentAttributes,
        payment.PaymentName,
        true,
      );
      // Reload only after a payment was confirmed. Closing the dialog with
      // Cancel must preserve the customer form entered on the page.
      await this.checkExistingDocument();
    }
  }

  async payByOthers(): Promise<void> {
    if (!this.canUseReturnPaymentMethod(ReturnPaymentMethod.Other)) {
      return;
    }

    const paymentModel = this.flyTicketForm.value as IFlyTicketFormModel;
    paymentModel.payments = this.payments.getValue();

    const dialogRef = this._dialog.open<OthersPaymentDialogComponent, PaymentDialogModel, PaymentDialogResult>(
      OthersPaymentDialogComponent,
      {
        panelClass: "full-screen-dialog",
        data: (await this.preparePaymentDialog(FlightToPaymentDialogModel(paymentModel, this.payments.getValue(), this.isReturn))),
      },
    );

    let result = await lastValueFrom(dialogRef.afterClosed());

    // Others can contain terminal-backed payment types (for example MALLCARD).
    // Resolve the marker before saving so the offline attributes reach savePayment().
    if (result?.openOfflineCardPaymentDialog && result.offlinePaymentDialogContext) {
      result = await this.openCardPaymentDialog(
        true,
        result.Amount,
        result.offlinePaymentDialogContext,
      );
    }

    if (!result) {
      return;
    }

    paymentModel.paymentValue = this.isReturn
      ? -Math.abs(result.Amount)
      : result.Amount;

    await this.savePayment(
      paymentModel,
      result.PaymentType,
      result.PaymentAttributes,
      result.PaymentName,
    );

    await this.checkExistingDocument();
  }

  private async showSuccessDialogAndHandleReceipt(headerUid: string): Promise<void> {
    const dialogMessage = this.isReturn ? "webPos.SuccessfullyReturned" : "webPos.SuccessfullyPayed";
    const emailAddress = this.flyTicketForm?.get("customerEmailAddress")?.value;

    const monitorDataResult = await this._headerProcessingService.monitorHeader(headerUid);
    const headerIdForPrint = await this._headerProcessingService.getHeaderIdFromResult(monitorDataResult);

    const result = await this._popUpDialogInformalService.confirm({
      title: this.translate.instant("webPos.Done"),
      message: this.translate.instant(dialogMessage),
      type: PopUpInformalType.Success,
      showPrintReceipt: true,
      showSendReceiptByEmail: true,
      emailAddress: emailAddress,
    });

    if (result?.printReceipt) {
      if (headerIdForPrint) {
        await this._reportExportService.downloadPdf(
          undefined,
          [{ key: 'HeaderID', value: headerIdForPrint.toString() }],
          true,
        );
      }
    }

    if (result?.email) {
      if (headerIdForPrint) {
        await this._reportExportService.sendPdfByEmail(
          result.email,
          headerIdForPrint,
        );
      }
    }

    this._spinner.hide();
  }

  async savePayment(
    flyTicket: IFlyTicketFormModel,
    paymentTypeEn: TenderType,
    paymentAttributes?: Array<IPaymentAttribute> | null,
    paymentName?: string,
    showSuccessDialog: boolean = true,
  ): Promise<{
    success: boolean;
    paymentUID?: string | null;
    headerUid?: string | null;
    errorMessage?: string | null;
    paymentOutcome?: PayByCardResult["outcome"];
  }> {
    const paymentValue = Number(flyTicket.paymentValue);

    if (!(await this.validateReturnPayment(paymentValue, paymentTypeEn))) {
      return { success: false };
    }

    const currency = this._stateService.currencyCode();

    const paymentTypes = await this._sharedService.getPaymentTypes();
    const paymentType = paymentTypes?.find(pt =>
      (paymentName ? pt.Name === paymentName : pt.TenderType === paymentTypeEn)
      && (!pt.Currency || pt.Currency === currency)
      && pt.Availability?.[this.paymentContext.operation]?.[this.paymentContext.documentType] === true);

    if (!paymentType) {
      await this._popUpDialogInformalService.confirm({
        title: this.translate.instant("webPos.Errors.Error"),
        message: this.translate.instant("webPos.FailedToCreateDocument"),
        type: PopUpInformalType.Error,
      });
      return { success: false };
    }

    let virtualProductType = VirtualProductType.FlightTicket;
    if (this.viewType === FlyTicketType.ETravel) {
      virtualProductType = VirtualProductType.ETravel;
    }

    const formattedBlobData: IBlobExportData = {
      id: flyTicket.variableSymbol,
      paymentValue: Number(flyTicket.paymentValue),
      paymentName: paymentType.Name,
      paymentAttributes: paymentAttributes || null,
      saleName: flyTicket.flyTicketName,
      customerName: flyTicket.customerName,
      customerSurname: flyTicket.customerSurname,
      description: flyTicket.description,
      visualStyle: null,
      sendEmail: null,
      customerStreet: flyTicket.customerStreet,
      customerCity: flyTicket.customerCity,
      customerCountry: flyTicket.customerCountry,
      customerZipCode: flyTicket.customerZipCode,
      customerPhoneNumber: null,
      customerEmailAddress: flyTicket.customerEmailAddress,
      customerCIN: flyTicket.customerCIN || null,
      customerTIN: flyTicket.customerTIN || null,
      virtualProductType: virtualProductType,
      virtualProductText: flyTicket.variableSymbol,
    };

    const model: IInsertHeaderRecordParams = {
      DataBlob: formattedBlobData,
      VirtualProductType: virtualProductType,
      DocID: flyTicket.variableSymbol,
      PaymentType: paymentType.TenderType,
      PaymentName: paymentType.Name,
      CurrencyISOCode: this._loginService.user.CurrencyCode,
      PaymentValue: paymentValue,
    };

    const createHeaderRecResult: IExecuteProcedureResult<IInsertDertHeadersResultData> = await this._sharedService.createPaymentRecord(model);

    const headerUid = createHeaderRecResult.data?.HeaderUID;

    if (!headerUid) {
      await this._popUpDialogInformalService.confirm({
        title: this.translate.instant("webPos.Errors.Error"),
        message: this.translate.instant("webPos.FailedToCreateDocument"),
        type: PopUpInformalType.Error,
      });
      //this._sharedService.navigateToDashboard();
      return { success: false };
    }

        // CHECK IF CONTINUE TO NON-CARD PAYMENT
    if (
      paymentType.TenderType !== TenderType.Card
      && paymentType.TenderType !== TenderType.ElectronicVoucher
    ) {
      if (showSuccessDialog) {
        await this.showSuccessDialogAndHandleReceipt(headerUid);
      }

      return { success: true, headerUid };
    }
    // CHECK IF CONTINUE TO CARD PAYMENT
    else if (
      paymentType.TenderType === TenderType.Card
      || paymentType.TenderType === TenderType.ElectronicVoucher
    ) {

      const paymentUID =createHeaderRecResult.data.PaymentUID;

      let valueToPay = createHeaderRecResult.data.PaymentValue;
      valueToPay = this.isReturn ? valueToPay * -1 : valueToPay;

      let paymentSuccessful = false;
      let sobitPaymentResult: PayByCardResult | null = null;
      if (this.isOfflineCardPayment(paymentAttributes)) {
        paymentSuccessful = await this._sobitService.registerOfflineCardPayment(
          paymentUID,
          paymentAttributes,
        );
      } else {
        sobitPaymentResult = await this._sobitService.payByCard({
          paymentUID,
          valueToPay,
          currencyIsoCode: model.CurrencyISOCode,
          isReturn: this.isReturn,
          showFailureDialog: this.isReturn,
          invNumber: this.isReturn ? undefined : flyTicket.variableSymbol,
        } satisfies PayByCardRequest);
        paymentSuccessful = sobitPaymentResult.outcome === "accepted";
      }
      this._spinner.hide();

      if (paymentSuccessful) {
        const dialogMessage = this.isReturn ? "webPos.SuccessfullyReturned" : "webPos.SuccessfullyPayed";
        const emailAddress = this.flyTicketForm?.get("customerEmailAddress")?.value || "";

        const cardDialogResult = await this._popUpDialogInformalService.confirm({
          title: this.translate.instant("webPos.Done"),
          message: this.translate.instant(dialogMessage),
          type: PopUpInformalType.Success,
          showPrintReceipt: true,
          showSendReceiptByEmail: true,
          emailAddress: emailAddress,
        });

        const monitorDataResult = await this._headerProcessingService.monitorHeader(headerUid);
        const headerIdForPrint = await this._headerProcessingService.getHeaderIdFromResult(monitorDataResult);

        if (cardDialogResult?.printReceipt && headerIdForPrint) {
          await this._reportExportService.downloadPdf(
            undefined,
            [{ key: 'HeaderID', value: headerIdForPrint.toString() }],
            true
          );
        }

        if (cardDialogResult?.email && headerIdForPrint) {
          await this._reportExportService.sendPdfByEmail(
            cardDialogResult.email,
            headerIdForPrint,
          );
        }

        this._spinner.hide();

        await this.checkExistingDocument();
      }
      else {
        return {
          success: false,
          paymentUID,
          headerUid,
          paymentOutcome: sobitPaymentResult?.outcome,
          errorMessage: sobitPaymentResult?.message ?? null,
        };
      }
    } 

    return { success: true, headerUid };

  }

  async payByCard() {
    if (!this.canUseReturnPaymentMethod(ReturnPaymentMethod.Card)) {
      return;
    }

    this.checkSobitPaymentEnabled.next(false);
    const useOfflineCardPayment = !this.allowPaymentByCard();

    const payments = await this._paymentTypesService.getPaymentTypesWithNominals(this.paymentContext);
    const currencyISOCode = this._loginService.user.CurrencyCode;;
    const selectedPayment = payments.find(p => p.TenderType === TenderType.Card && p.Currency === currencyISOCode);

    const paymentModel = this.flyTicketForm.value as IFlyTicketFormModel;
    paymentModel.payments = this.payments.getValue();

    let result = await this.openCardPaymentDialog(useOfflineCardPayment);
    if (result) {
      this._spinner.show();
      paymentModel.paymentValue = result.Amount;
      if (this.isReturn) {
        paymentModel.paymentValue = - paymentModel.paymentValue;
      }
      const paymentResult = await this.savePayment(
        paymentModel,
        TenderType.Card,
        result.PaymentAttributes,
        result.PaymentName,
      );

      if (!paymentResult.success && !this.isReturn && paymentResult.paymentUID && paymentResult.headerUid) {
        if (paymentResult.paymentOutcome === "handled") {
          return;
        }

        if (useOfflineCardPayment) {
          const offlineSaved = await this._sobitService.registerOfflineCardPayment(
            paymentResult.paymentUID,
            result.PaymentAttributes,
          );

          if (offlineSaved) {
            await this.showSuccessDialogAndHandleReceipt(paymentResult.headerUid);
          }

          await this.checkExistingDocument();
          return;
        }

        const continueOffline = await this.confirmOfflinePaymentFallback();

        if (continueOffline) {
          const offlineResult = await this.openCardPaymentDialog(true, result.Amount);

          if (offlineResult) {
            const offlineSaved = await this._sobitService.registerOfflineCardPayment(
              paymentResult.paymentUID,
              offlineResult.PaymentAttributes,
            );

            if (offlineSaved) {
              await this.showSuccessDialogAndHandleReceipt(paymentResult.headerUid);
            }
          }
        }
      }
    }
    // Closing the dialog with Cancel must not recreate the customer form.
    if (result) {
      await this.checkExistingDocument();
    }
  }

  private async openCardPaymentDialog(
    offlineMode = false,
    initialAmountToPay?: number,
    offlinePaymentContext?: OfflinePaymentDialogContext | null,
  ): Promise<IPayment | null> {
    const paymentModel = this.flyTicketForm.value as IFlyTicketFormModel;
    paymentModel.payments = this.payments.getValue();

    const baseData: PaymentDialogModel = {
      ...(await this.preparePaymentDialog(FlightToPaymentDialogModel(paymentModel, this.payments.getValue(), this.isReturn))),
      initialAmountToPay: initialAmountToPay ?? null,
      offlinePaymentContext: offlinePaymentContext ?? null,
    };

    if (offlineMode) {
      const dialogRef = this._dialog.open<OfflineCardPaymentDialogComponent, PaymentDialogModel, IPayment>(
        OfflineCardPaymentDialogComponent,
        { panelClass: "full-screen-dialog", data: baseData },
      );
      return lastValueFrom(dialogRef.afterClosed());
    }

    const dialogRef = this._dialog.open<CardPaymentDialogComponent, PaymentDialogModel, PaymentDialogResult>(
      CardPaymentDialogComponent,
      { panelClass: "full-screen-dialog", data: baseData },
    );
    const result = await lastValueFrom(dialogRef.afterClosed());

    // Open the offline form from the parent to avoid stacking two full-screen
    // Material dialogs. The amount and payment metadata come from the closed form.
    if (!result?.openOfflineCardPaymentDialog) {
      return result;
    }

    return this.openCardPaymentDialog(true, result.Amount, result.offlinePaymentDialogContext);
  }

  private async resolveBenefitPaymentDialogResult(result: PaymentDialogResult | null): Promise<IPayment | null> {
    if (!result) {
      return null;
    }

    if (!result.openOfflineCardPaymentDialog || !result.offlinePaymentDialogContext) {
      return result;
    }

    return this.openCardPaymentDialog(
      true,
      result.Amount,
      result.offlinePaymentDialogContext,
    );
  }

  private async confirmOfflinePaymentFallback(): Promise<boolean> {
    const result = await this._popUpDialogInformalService.confirm({
      title: "webPos.Errors.Error",
      message: "webPos.PaymentWithCardFailed",
      type: PopUpInformalType.Error,
      confirmButtonText: "webPos.PayOffline",
      cancelButtonText: "webPos.Cancel",
      showCancelButton: true,
    });

    return !!result?.confirmed;
  }

  public async payByCash() {
    if (!this.canUseReturnPaymentMethod(ReturnPaymentMethod.Cash)) {
      return;
    }

    const paymentModel = this.flyTicketForm.value as IFlyTicketFormModel;
    paymentModel.payments = this.payments.getValue();

    const dialogRef = this._dialog.open<CashPaymentDialogComponent, PaymentDialogModel, IPayment>(CashPaymentDialogComponent, {
      panelClass: "full-screen-dialog",
      data: (await this.preparePaymentDialog(FlightToPaymentDialogModel(paymentModel, this.payments.getValue(), this.isReturn))),
    });

    const result = await lastValueFrom(dialogRef.afterClosed());

    if (result) {
      this._spinner.show();
      paymentModel.paymentValue = result.Amount;
      if (this.isReturn) {
        paymentModel.paymentValue = - paymentModel.paymentValue;
      }
      await this.savePayment(paymentModel, TenderType.Cash, result.PaymentAttributes, result.PaymentName);
      // Reload only after a payment was confirmed. Closing the dialog with
      // Cancel must preserve the customer form entered on the page.
      await this.checkExistingDocument();
    }
  }

  ngOnDestroy() {
    this.destroyObservable$.next(true);
    this.destroyObservable$.complete();
    this.checkDocumentSubject$.complete();
  }

  public canUseReturnPaymentMethod(method: ReturnPaymentMethod): boolean {
    if (!this.isReturn) {
      // Applying an existing voucher is a separate flow entered through
      // ?voucher=... and the template renders that flow exclusively.
      if (this.voucherCodeFromQuery) {
        return false;
      }
      // Benefits are only meaningful for the eTravel sale. Standard flight
      // sales expose cash, card and configured OC/Škoda "Other" payments.
      if (method === ReturnPaymentMethod.Benefits && this.viewType !== FlyTicketType.ETravel) {
        return false;
      }
      if (method === ReturnPaymentMethod.Voucher) {
        return false;
      }
    }

    const authorized = !this.isReturn || isAuthorizedForReturnPaymentMethod(this._loginService.user?.Roles, method);
    // Issuing a refund voucher is a separate operation, not a tender refund.
    return authorized && ((this.isReturn && method === ReturnPaymentMethod.Voucher)
      || this.paymentAvailability.has(this.paymentContext, method));
  }

  private isOfflineCardPayment(paymentAttributes?: Array<IPaymentAttribute> | null): boolean {
    return !!paymentAttributes?.some(attribute =>
      attribute?.Key === "Type"
      && attribute?.Value?.toString?.().toUpperCase() === "OFFLINE"
    );
  }
}
